/* eslint-disable */
import Helper from "./util/Helper";

'use strict';

const urlParams = new URLSearchParams(window.location.search);

let utmSources = (Helper.getCookie('utmSources') !== undefined || Helper.getCookie('utmSources') !== null) ? Helper.getCookie('utmSources') : null;
if (window.location.search !== '' && window.location.search.includes('utm_')) {
    utmSources = {};
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.forEach(function (value, key) {
        if (key === 'portal') {
            return;
        }
        const utmKey = key.replace('_', '');
        utmSources[key] = utmKey + '_' + value;
    });
    utmSources = Object.values(utmSources).join('AND');
}

/* Start Cookie */
// set cookie for Google Analytics utmSources and fill hidden input
if ((!Helper.getCookie('utmSources') && !!utmSources) || (Helper.getCookie('utmSources') !== utmSources && !!utmSources)) {
    Helper.setCookie('utmSources', utmSources, 0, true);
}
/* End Cookie */

/* Zapier Webhooks */
if (!!form_sources_js_vars.zapierWebhookUrl) {
    window.onload = function () {
        let url = window.location.origin + window.location.pathname.replace(/\/$/, ''),
            wanted = window.location.origin + '/newsletter/anmeldung-erfolgreich',
            params = {
                email: getUrlParam('email'),
                newsletter: getUrlParam('newsletter')
            };

        if (url === wanted) {
            sendZapierHook(params);
        }
    };
}


/**
 * Send Zapier Hook
 * @param params
 */
function sendZapierHook(params) {
    fetch(form_sources_js_vars.zapierWebhookUrl, {
        method: 'POST',
        body: JSON.stringify(params)
    }).then(res => res.json())
        .then(res => console.log(res));
}

/**
 * @param param
 * @returns {string|string}
 */
function getUrlParam(param) {
    return urlParams.get(param) ? urlParams.get(param) : ''
}


// WEBPACK FOOTER //
// ./scripts/form-sources.js